import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PartDialogData {
  EquipId: string;
  EquipDesc: string;
  AvailableQuantity: string;
  MachineName: string;
  DivisionId: string
}

@Component({
  selector: 'partlisthistory-dialog',
  templateUrl: './PartListHistoryDialog.html',
})

export class PartListHistoryDialog {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PartDialogData
  ) {
  }
}